/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutGuestProfileViewProps } from '@msdyn365-commerce-modules/checkout/src/modules/checkout-guest-profile/checkout-guest-profile';
import { IAddContactInfo } from '@msdyn365-commerce-modules/checkout/src/modules/checkout-guest-profile/components/get-add-contact-info';
import { IShowContactInfo } from '@msdyn365-commerce-modules/checkout/src/modules/checkout-guest-profile/components/get-show-contact-info';

export const ShowContactInfo: React.FC<IShowContactInfo> = ({ showInfoProps, email, editButton }) => (
    <Node {...showInfoProps}>
        {email}
        {editButton}
    </Node>
);
export const AddContactInfo: React.FC<IAddContactInfo> = ({
    addFormProps,
    submitButton,
    cancelButton,
    inputGroupProps,
    label,
    error,
    input
}) => (
    <Node {...addFormProps}>
        <Node {...inputGroupProps}>
            {'Email Address'}
            {error}
            {input}
        </Node>
        {submitButton}
        {cancelButton}
    </Node>
);

const CheckoutGuestProfileView: React.FC<ICheckoutGuestProfileViewProps> = ({ moduleProps, showContactInfo, addContactInfo }) => {
    return (
        <Module {...moduleProps}>
            {showContactInfo && <ShowContactInfo {...showContactInfo} />}
            {addContactInfo && <AddContactInfo {...addContactInfo} />}
        </Module>
    );
};

export default CheckoutGuestProfileView;
